export const ICityLookupApiId = Symbol.for('ICityLookupApi');

export interface ICityLookupApi {
    getCityNameByPostalCode(apiUrl: string, postalCode: string): Promise<any>;
}
